// extracted by mini-css-extract-plugin
export default {"projectsBlock":"Projects_projectsBlock__LsSmq","container":"Projects_container__aXsIK","projects":"Projects_projects__M-BHt"};